module.exports = __webpack_public_path__ + "img/icon.425bd90a.png";